import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { generateTranslateMuiTable } from '../../../utils/Function/commonFunction';
import { CustomAdvancedMenuList, StyledDataGrid } from '../../../components/StyledComponents';
import CustomPagination from '../CustomPagination';
import NoRowOverlay from '../../../assets/images/icons/NoRowOverlay';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import DeleteIcon16pxSvg from '../../../assets/images/icons/DeleteIcon16pxSvg';
import RemoveUserDialog from './RemoveUserDialog';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DetailVisitorDialog from './DetailVisitorDialog';
import { useAuth } from '../../../context/AuthContext';
import dayjs from 'dayjs';
import { format, parseISO } from "date-fns";
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import AddIcon from '@mui/icons-material/Add';
import CustomSearch from '../../../components/CustomSearch';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import ExportIcon16pxSvg from '../../../assets/images/icons/ExportIcon16pxSvg';
import AddVisitorUserDialog from './AddVisitorUserDialog';

const VisitorUserEventGridInfoTable = ({ onRowClick, refreshData, handleRefreshData }) => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [filteredRowCount, setFilteredRowCount] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [removeUserOpen, setRemoveUserOpen] = useState(false);
    const [detailVisitorOpen, setDetailVisitorOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const { genaralSettingDateFormat } = useAuth();
    const [addVisitorUserOpen, setAddVisitorUserOpen] = useState(false);
    const [openAdvanced, setOpenAdvanced] = useState(false);

    const anchorRefAdvanced = useRef(null);
    const handleQuickFilterChange = () => {
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    const handleCloseRemoveUser = () => {
        setRemoveUserOpen(false);
    };

    const handleOpenRemoveUser = () => {
        setRemoveUserOpen(true);
    };

    const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);

    const columnData = [
        { field: 'fullName', headerName: t('common.name'), hideable: true, flex: 1, },
        { field: 'personalID', headerName: t('common.personal-id'), hideable: true, flex: 1, },
        { field: 'email', headerName: t('common.email'), hideable: true, flex: 1, },
    ];

    const handleRowsPerPageChange = (newPageSize) => {
        // newPageSize ở đây tuỳ CustomPagination, có thể là event hoặc number
        const size =
            typeof newPageSize === "number"
                ? newPageSize
                : parseInt(newPageSize.target.value, 10);

        setPage((prevPage) => {
            // index của record đầu tiên đang xem
            const firstRowIndex = prevPage * pageSize;

            // page mới sao cho vẫn chứa record đó
            const newPage = Math.floor(firstRowIndex / size);

            // phòng trường hợp vượt quá số trang
            const maxPage = Math.max(
                0,
                Math.ceil(filteredRowCount / size) - 1
            );

            return Math.min(newPage, maxPage);
        });

        setPageSize(size);
    };

    const handleRowClick = (params) => {
        const rowData = params.row;
        if (rowData) {
            onRowClick(rowData);
        }
    };

    return (
        <>
            <div className='flex flex-col gap-2'>
                <Fragment>
                    <StyledDataGrid
                        showColumnVerticalBorder
                        sx={{
                            height: 650,

                            "@media (max-width: 1919px)": {
                                height: 750,
                            },

                            ".MuiDataGrid-main": {
                                height: "70vh",
                            },

                            "& .MuiDataGrid-scrollbar--vertical, & .MuiDataGrid-scrollbar--horizontal":
                            {
                                display: "none !important",
                            },

                            "& .MuiDataGrid-scrollbarFiller": {
                                display: "none !important",
                            },
                            "& .MuiDataGrid-columnHeaders": {
                                paddingRight: 0,
                            },
                            "& .MuiDataGrid-topContainer": {
                                paddingRight: 0,
                            },

                            "&": {
                                "--DataGrid-scrollbarSize": "0px",
                            },

                            "& .MuiDataGrid-virtualScroller": {
                                scrollbarWidth: "none",
                            },
                            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                                width: 0,
                                height: 0,
                            },
                            "&:hover .MuiDataGrid-virtualScroller, &:focus-within .MuiDataGrid-virtualScroller":
                            {
                                scrollbarWidth: "thin",
                            },
                            "&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar, &:focus-within .MuiDataGrid-virtualScroller::-webkit-scrollbar":
                            {
                                width: 10,
                                height: 10,
                            },

                            '& [class*="MuiDataGrid-scrollbar"][class*="--horizontal"]': {
                                display: "none !important",
                            },

                            "& input[type=number]::-webkit-inner-spin-button, \
 & input[type=number]::-webkit-outer-spin-button": {
                                WebkitAppearance: "none",
                                margin: 0,
                            },

                            "& input[type=number]": {
                                textAlign: "center",
                                MozAppearance: "textfield",
                                WebkitAppearance: "none",
                                padding: "5px !important",
                                height: "100%",
                                pointerEvents: "none",
                                caretColor: "transparent",
                                userSelect: "none",
                                paddingTop: "8px !important",
                                paddingBottom: "8px !important"
                            },
                        }}
                        rows={data || []}
                        rowCount={rowCount}
                        paginationMode="client"
                        columns={columnData}
                        // loading={gridLoading}
                        getRowId={(r) => r.id}
                        slots={{
                            pagination: CustomPagination,
                            noRowsOverlay: NoRowOverlay,
                            columnsPanel: CustomColumnsPanel,
                        }}
                        slotProps={{
                            pagination: {
                                page,
                                count: rowCount,
                                rowsPerPage: pageSize,
                                onPageChange: setPage,
                                onRowsPerPageChange: handleRowsPerPageChange,
                            },
                        }}
                        localeText={tableTranslated}
                        onRowClick={handleRowClick} />
                </Fragment>
            </div>
        </>
    )
}

export default VisitorUserEventGridInfoTable